import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AthletesTable } from "@/components/athletes-table";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";

export const Route = createFileRoute("/(protected)/athletes/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="h-max space-y-6 pr-6 pl-6 md:px-6">
        <MobilePageTitle className="mt-6 mb-4">
          {t("pages:dashboard.sidebar.athletes")}
        </MobilePageTitle>
        <AthletesTable />
      </div>
    </ScrollableContainer>
  );
}
